const fr = {
    common: {
        history: "version historique"
    }
};
export default fr;



// WEBPACK FOOTER //
// ./src/i18n/langs/fr.js